/* ============================================
   LAUZA — JavaScript principal
   Source unique — identique au preview
   ============================================ */
(function() {
  'use strict';

  var INIT_KEY = 'lauzaInit';

  function resetState() {
    var mobileM  = document.getElementById('mobileMenu');
    var toggle   = document.getElementById('menuToggle');
    var dropdown = document.getElementById('navDropdown');
    var trigger  = document.getElementById('dropdownTrigger');
    var overlay  = document.getElementById('searchOverlay');
    if (mobileM)  { mobileM.classList.remove('active'); mobileM.setAttribute('aria-hidden','true'); }
    if (toggle)   { toggle.classList.remove('active'); toggle.setAttribute('aria-expanded','false'); }
    if (dropdown) { dropdown.classList.remove('open'); }
    if (trigger)  { trigger.setAttribute('aria-expanded','false'); }
    if (overlay)  { overlay.classList.remove('active'); }
    document.body.style.overflow = '';
  }

  function init() {
    if (document.documentElement.dataset[INIT_KEY]) { resetState(); return; }
    document.documentElement.dataset[INIT_KEY] = '1';

    var header  = document.getElementById('header');
    var bar     = document.getElementById('scrollProgress');
    var mobileM = document.getElementById('mobileMenu');
    var toggle  = document.getElementById('menuToggle');
    var dropdown= document.getElementById('navDropdown');
    var trigger = document.getElementById('dropdownTrigger');
    var overlay = document.getElementById('searchOverlay');
    var sToggle = document.getElementById('searchToggle');
    var sClose  = document.getElementById('searchClose');
    var backBtn = document.getElementById('backToTop');

    /* SCROLL */
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (header)  header.classList.toggle('scrolled', y > 60);
      if (bar)     bar.style.width = (h > 0 ? (y/h)*100 : 0) + '%';
      if (backBtn) backBtn.classList.toggle('visible', y > 400);
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();

    /* MENU MOBILE */
    if (toggle && mobileM) {
      toggle.addEventListener('click', function() {
        var open = mobileM.classList.toggle('active');
        toggle.classList.toggle('active', open);
        toggle.setAttribute('aria-expanded', String(open));
        mobileM.setAttribute('aria-hidden', String(!open));
        document.body.style.overflow = open ? 'hidden' : '';
      });
      mobileM.querySelectorAll('a').forEach(function(a) {
        a.addEventListener('click', function() {
          mobileM.classList.remove('active');
          toggle.classList.remove('active');
          toggle.setAttribute('aria-expanded','false');
          mobileM.setAttribute('aria-hidden','true');
          document.body.style.overflow = '';
        });
      });
    }

    /* DROPDOWN BOUTIQUE */
    if (dropdown && trigger) {
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var open = dropdown.classList.toggle('open');
        trigger.setAttribute('aria-expanded', String(open));
      });
      dropdown.querySelectorAll('.dropdown-menu a').forEach(function(link) {
        link.addEventListener('click', function() {
          dropdown.classList.remove('open');
          trigger.setAttribute('aria-expanded','false');
        });
      });
      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('open');
          trigger.setAttribute('aria-expanded','false');
        }
      });
    }

    /* ESCAPE */
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      if (dropdown) { dropdown.classList.remove('open'); if(trigger) trigger.setAttribute('aria-expanded','false'); }
      if (overlay)  { overlay.classList.remove('active'); }
      if (mobileM && mobileM.classList.contains('active')) {
        mobileM.classList.remove('active');
        if (toggle) { toggle.classList.remove('active'); toggle.setAttribute('aria-expanded','false'); }
        mobileM.setAttribute('aria-hidden','true');
        document.body.style.overflow = '';
      }
    });

    /* RECHERCHE */
    if (sToggle && overlay) {
      sToggle.addEventListener('click', function() {
        overlay.classList.add('active');
        var inp = overlay.querySelector('input');
        if (inp) setTimeout(function(){ inp.focus(); }, 50);
      });
    }
    if (sClose && overlay) {
      sClose.addEventListener('click', function() { overlay.classList.remove('active'); });
    }
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) overlay.classList.remove('active');
      });
    }

    /* RETOUR EN HAUT */
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        window.scrollTo({top:0, behavior:'smooth'});
      });
    }

    /* FAQ ACCORDION */
    document.querySelectorAll('.faq-question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item.open').forEach(function(i){ i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });

    /* PANIER AJAX */
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(data) {
        document.querySelectorAll('.cart-count').forEach(function(el) {
          el.textContent = data.item_count;
          el.style.display = data.item_count > 0 ? 'flex' : 'none';
        });
      }).catch(function(){});

    /* SCROLL REVEAL */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            obs.unobserve(entry.target);
          }
        });
      }, {threshold:0.1, rootMargin:'0px 0px -40px 0px'});
      document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .product-card, .testimonial-card, .trust-block, .faq-item').forEach(function(el) {
        obs.observe(el);
      });
      setTimeout(function() {
        document.querySelectorAll('.hero .reveal').forEach(function(el){ el.classList.add('revealed'); });
      }, 100);
    }

    /* SMOOTH SCROLL */
    document.querySelectorAll('a[href^="#"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var id = a.getAttribute('href');
        if (id === '#') return;
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          var offset = (header ? header.offsetHeight : 88) + 16;
          window.scrollTo({top: target.getBoundingClientRect().top + window.scrollY - offset, behavior:'smooth'});
        }
      });
    });
  }

  /* INIT MULTI-SCÉNARIOS */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* bfcache — mobile Safari/Chrome */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      delete document.documentElement.dataset[INIT_KEY];
      resetState();
      init();
    }
  });

  /* Shopify Theme Editor */
  document.addEventListener('shopify:section:load', function() {
    delete document.documentElement.dataset[INIT_KEY];
    init();
  });

})();

